import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BrowserService} from '@core/service/browser.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  private readonly router = inject(Router);
  private readonly browserService = inject(BrowserService);

  public navigate(commands: any[]): Promise<boolean> {
    // navigation hinders SSR performances because the SSR engine waits
    // promises to resolve. If we are not in the browser context -> resolve immediatelly.
    if (!this.browserService.isBrowser) {
      return Promise.resolve(false);
    }
    return this.router.navigate(commands);
  }
}
